// Element & default i18n; managed by Vue-i18n
import element_en from '@/plugins/i18n/element_en'
import element_fr from '@/plugins/i18n/element_fr'
import en from './en.json'
import fr from './fr.json'
export const defaultLocale = localStorage.getItem('language') || 'fr'

export const languages = {
  fr: { ...fr, ...element_fr },
  en: { ...en, ...element_en }
}
